module.exports = __webpack_public_path__ + "img/icon-white-30.ee798ab6.svg";